// @avantia common-code
import {
  HpRemoveEndingProps,
  HpRemoveEndingResult,
  HpVisibleQuestionCustomization
} from './questionSetToolsCustomizationInterface';

export const visibleQuestionDefaultCustomization: HpVisibleQuestionCustomization = {
  name: 'standard',
  ignoreRepeaterWithNoGroup: true,
  removeEnding,
  splitQuestionId
};

function splitQuestionId(questionId: string): string[] {
  return [questionId];
}

function removeEnding({ forParent, indexes, parts }: HpRemoveEndingProps): HpRemoveEndingResult {
  indexes = indexes || [];
  if (forParent && indexes.length > 0) {
    indexes.length--; // shrink it
  }

  return { indexes, parts, groupNumber: indexes[indexes.length - 1] };
}
